export const WALLBOARD_REFRESH_INTERVALS = [5, 10, 15, 30, 60] as const;
export type WallboardRefreshInterval = (typeof WALLBOARD_REFRESH_INTERVALS)[number];

export const DEFAULT_WALLBOARD_REFRESH_INTERVAL: WallboardRefreshInterval = 5;
export const WALLBOARD_REFRESH_STORAGE_KEY = "faro-wallboard-refresh-seconds";

type ReadableStorage = Pick<Storage, "getItem">;
type WritableStorage = Pick<Storage, "setItem">;

export function parseWallboardRefreshInterval(value: string | null): WallboardRefreshInterval {
  const parsed = Number(value);
  return WALLBOARD_REFRESH_INTERVALS.includes(parsed as WallboardRefreshInterval)
    ? parsed as WallboardRefreshInterval
    : DEFAULT_WALLBOARD_REFRESH_INTERVAL;
}

export function readStoredWallboardRefreshInterval(storage: ReadableStorage): WallboardRefreshInterval {
  try {
    return parseWallboardRefreshInterval(storage.getItem(WALLBOARD_REFRESH_STORAGE_KEY));
  } catch {
    return DEFAULT_WALLBOARD_REFRESH_INTERVAL;
  }
}

export function storeWallboardRefreshInterval(
  storage: WritableStorage,
  interval: WallboardRefreshInterval,
): void {
  try {
    storage.setItem(WALLBOARD_REFRESH_STORAGE_KEY, String(interval));
  } catch {
    // Storage can be disabled by browser policy; the setting still works for this session.
  }
}
